import * as tslib_1 from "tslib";
import React from 'react';
import Select from '@sinoui/select-field';
import EditableSelect from './EditableSelect';
export default function EditableSelectField(props) {
    return React.createElement(Select, tslib_1.__assign({ nativeSelectComponent: EditableSelect }, props));
}
//# sourceMappingURL=EditableSelectField.js.map